export default __webpack_public_path__ + "14c4384cb17384f4a8a1d078efb010bc.png";